import * as React from "react";
import type { SVGProps } from "react";
const SvgElevatorFilledWithPeople = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M15.62 5.93a1 1 0 0 1-.33-.22h.02l-2-2a.996.996 0 1 1 1.41-1.41l.29.29V1c0-.55.45-1 1-1s1 .45 1 1v1.59l.29-.29a.996.996 0 1 1 1.41 1.41l-2 2c-.1.1-.21.17-.33.22s-.25.08-.38.08-.26-.03-.38-.08M6.71 3.71 7 3.42v1.59c0 .55.45 1 1 1s1-.45 1-1V3.42l.29.29c.2.2.45.29.71.29s.51-.1.71-.29a.996.996 0 0 0 0-1.41l-2-2a1 1 0 0 0-1.42 0l-2 2A.996.996 0 1 0 6.7 3.71zM17 13a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M16 18.41V20c0 .55.45 1 1 1s1-.45 1-1v-1.59l.71-.71a1 1 0 0 0 .29-.71v-1.5c0-1.1-.9-2-2-2s-2 .9-2 2v1.5c0 .27.11.52.29.71zM11 20v-1.59l-.71-.71c-.18-.19-.29-.44-.29-.71v-1.5c0-1.1.9-2 2-2s2 .9 2 2v1.5c0 .27-.1.52-.29.71l-.71.71V20c0 .55-.45 1-1 1s-1-.45-1-1M12 13a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M6 20v-1.59l-.71-.71c-.18-.19-.29-.44-.29-.71v-1.5c0-1.1.9-2 2-2s2 .9 2 2v1.5c0 .27-.1.52-.29.71l-.71.71V20c0 .55-.45 1-1 1s-1-.45-1-1M7 13a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3 7h18c.55 0 1 .45 1 1v15c0 .55-.45 1-1 1H3c-.55 0-1-.45-1-1V8c0-.55.45-1 1-1m1 2v13h16V9z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgElevatorFilledWithPeople;
